import { EventPageProps } from "/Models/Generated/EventPageProps";
import "./EventPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import {
  HeroWithImage,
  ContentArea,
  GridRow,
  MainIntro,
  GridPresetSidebar,
  GridPresetMainContent,
  MetaInfoBlock,
  ScheduleInfo,
  Link,
  OptimizelyEditProperty,
  ArrowLineUpRightIcon,
} from "/App.Components";
import { HasContent } from "../../Shared/ContentArea/ContentArea";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";
import { createSpreadableBem } from "/Helpers/createBem";

const EventPage = ({
  pageHeader,
  mainIntro,
  mainIntroPropertyName,
  mainBody,
  metaInfoBlock,
  scheduleInfo,
  linkToEvent,
  linkToEventPropertyName,
  sideBar,
  bottomContentArea,
}: EventPageProps) => {
  const bem = createSpreadableBem("event-page-norad");
  return (
    <div {...bem("")}>
      {pageHeader && <HeroWithImage {...pageHeader} />}
      {(mainBody || mainIntro || sideBar) && (
        <div {...bem("__main-body")}>
          <GridRow>
            <GridPresetMainContent>
              {scheduleInfo && (
                <div {...bem("__schedule-info")}>
                  <ScheduleInfo {...scheduleInfo} />
                </div>
              )}
              {(linkToEvent || linkToEventPropertyName) && (
                <div {...bem("__register-link")}>
                  <OptimizelyEditProperty
                    propertyName={linkToEventPropertyName}
                  >
                    {linkToEvent && (
                      <Link
                        {...linkToEvent}
                        icon={
                          linkToEvent.isExternal
                            ? ArrowLineUpRightIcon
                            : undefined
                        }
                        iconPlacement="after"
                      />
                    )}
                  </OptimizelyEditProperty>
                </div>
              )}
              {(mainIntro || mainIntroPropertyName) && (
                <MainIntro {...{ mainIntro, mainIntroPropertyName }} />
              )}
              {mainBody && (
                <ContentArea
                  {...mainBody}
                  contentAreaType={ContentAreaType.HalfWidth}
                />
              )}
            </GridPresetMainContent>
            {HasContent(sideBar) && (
              <GridPresetSidebar>
                <aside>
                  <ContentArea
                    {...sideBar}
                    margin={ContentAreaItemMargin.Sidebar}
                    contentAreaType={ContentAreaType.OneThird}
                  />
                </aside>
              </GridPresetSidebar>
            )}
          </GridRow>
        </div>
      )}
      {metaInfoBlock && (
        <div {...bem("__meta-info-block-container")}>
          <GridRow>
            <GridPresetMainContent>
              <MetaInfoBlock {...metaInfoBlock} />
            </GridPresetMainContent>
          </GridRow>
        </div>
      )}
      <ContentArea
        {...bottomContentArea}
        contentAreaType={ContentAreaType.FullWidth}
      />
    </div>
  );
};

export default EventPage;
